// src/themes/theme.ts
import { createTheme } from "@mui/material/styles";
import colors from "./variables";

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    success: {
      main: colors.success,
    },
    error: {
      main: colors.error,
    },
    info: {
      main: colors.info,
    },
    warning: {
      main: colors.warning,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          marginBottom: "8px",
          padding: "12px 24px",
        },
      },
    },
  },
});

export default theme;
